"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EKeyCode = void 0;
let EKeyCode = exports.EKeyCode = /*#__PURE__*/function (EKeyCode) {
  EKeyCode[EKeyCode["Backspace"] = 8] = "Backspace";
  EKeyCode[EKeyCode["Enter"] = 13] = "Enter";
  return EKeyCode;
}({});